module.exports = __webpack_public_path__ + "static/media/elixir-printing.54682f68.pdf";